/* cpg-product-main.js — extracted 2026-07-16 from sections/product_template.liquid (the 60.7 KB DOMContentLoaded block; Liquid product data now read from window.CPG_PT_DATA — see the inline bridge in the section)
 * as part of the core-regulation speed fixes. Loaded with defer (runs after HTML parse,
 * before DOMContentLoaded — identical behavior to the original inline position). */


  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cpg-product-section]').forEach(function (section) {
      var variantsScript = section.querySelector('[data-cpg-variants-json]');
      var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
      var variantInput = section.querySelector('[data-cpg-variant-id]');
      var addButton = section.querySelector('.cpg-product__add');
      var stickyAdd = section.querySelector('[data-cpg-sticky-add]');
      var qtyInput = section.querySelector('[data-cpg-qty]');
      var productAvailable = variants.some(function (variant) { return Boolean(variant.available); }) || window.CPG_PT_DATA.productAvailable;
      var productId = String(window.CPG_PT_DATA.productId);
      var requiresFitment = true;
      var productFitmentDataState = 'unknown';
      var fitmentDetectionStartedAt = Date.now();
      var fitmentStatus = 'missing';
      var selectedVehicleText = '';
      var lastAppliedFitmentKey = '';
      var fitmentResolveTimer = null;
      var isResolvingFitment = false;
      var cartFitmentMessageLocked = false;
      var lastVehicleSignature = '';
      var lastKnownVehicleText = '';

      function formatMoney(cents) {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          return Shopify.formatMoney(cents, window.CPG_PT_DATA.moneyFormat);
        }

        return (cents / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: window.CPG_PT_DATA.cartCurrency
        });
      }

      function normalizeText(value) {
        return String(value || '').replace(/\s+/g, ' ').trim();
      }

      function getSafeObjectValue(object, keys) {
        if (!object || typeof object !== 'object') return '';

        for (var i = 0; i < keys.length; i += 1) {
          if (object[keys[i]] !== undefined && object[keys[i]] !== null && object[keys[i]] !== '') {
            return object[keys[i]];
          }
        }

        return '';
      }

      function getConvermaxProductId() {
        return productId;
      }

      function isConvermaxReady() {
        // CPG teardown: our own fitment engine (cpg-ymm-widget.js) satisfies the
        // same adapter contract; Convermax remains a fallback while installed.
        return Boolean(window.CPGFitment || window.Convermax);
      }

      function isVehicleSelected() {
        if (window.CPGFitment) {
          try { return Boolean(window.CPGFitment.hasVehicle()); } catch (error) {}
        }
        if (!window.Convermax) return false;

        try {
          if (typeof window.Convermax.isVehicleSelected === 'function') {
            return Boolean(window.Convermax.isVehicleSelected());
          }
        } catch (error) {}

        return Boolean(getSelectedVehicleText());
      }

      function getSelectedVehicleText() {
        if (window.CPGFitment) {
          try {
            var cpgText = normalizeText(window.CPGFitment.getVehicleText());
            if (cpgText) return cpgText;
          } catch (error) {}
          if (!window.Convermax) return '';
        }
        if (!window.Convermax) return '';

        try {
          if (typeof window.Convermax.isVehicleSelected === 'function' && !window.Convermax.isVehicleSelected()) {
            return '';
          }
        } catch (error) {}

        try {
          if (typeof window.Convermax.getVehicleString === 'function') {
            var text = normalizeText(window.Convermax.getVehicleString());
            if (text) return text;
          }
        } catch (error) {}

        try {
          if (typeof window.Convermax.getVehicle === 'function') {
            var vehicle = window.Convermax.getVehicle();

            if (vehicle && typeof vehicle === 'object') {
              var parts = [
                getSafeObjectValue(vehicle, ['Year', 'year', 'YMM_Year']),
                getSafeObjectValue(vehicle, ['Make', 'make', 'YMM_Make']),
                getSafeObjectValue(vehicle, ['Model', 'model', 'YMM_Model']),
                getSafeObjectValue(vehicle, ['Submodel', 'submodel', 'Trim', 'trim', 'YMM_Submodel']),
                getSafeObjectValue(vehicle, ['Engine', 'engine', 'YMM_Engine'])
              ].filter(Boolean);

              if (parts.length) return normalizeText(parts.join(' '));
            }
          }
        } catch (error) {}

        return '';
      }

      function getVehicleSignature() {
        var vehicleText = getSelectedVehicleText();
        var selected = isVehicleSelected() ? '1' : '0';
        var storageSignature = '';

        ['localStorage', 'sessionStorage'].forEach(function (storageName) {
          try {
            var storage = window[storageName];
            var parts = [];

            for (var i = 0; i < storage.length; i += 1) {
              var key = storage.key(i);

              if (/cm|convermax|vehicle|garage|ymm|fitment/i.test(key || '')) {
                parts.push(key + ':' + storage.getItem(key));
              }
            }

            storageSignature += parts.sort().join('|');
          } catch (error) {}
        });

        return selected + '|' + vehicleText + '|' + storageSignature;
      }

      function setNodeHidden(nodes, shouldHide) {
        nodes.forEach(function (node) {
          node.hidden = shouldHide;
          node.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
        });
      }

      function updateVehicleText(text) {
        section.querySelectorAll('[data-cpg-vehicle-text]').forEach(function (node) {
          node.textContent = text || '';
        });
      }

      function applyFitmentState(status, vehicleText) {
        var nextVehicleText = vehicleText || '';
        var nextRequiresFitment = status !== 'no-data' && status !== 'universal' && status !== 'build-spec';
        var nextKey = status + '|' + nextVehicleText + '|' + (nextRequiresFitment ? '1' : '0');

        if (lastAppliedFitmentKey === nextKey) return;

        lastAppliedFitmentKey = nextKey;
        requiresFitment = nextRequiresFitment;
        fitmentStatus = status;
        selectedVehicleText = nextVehicleText;
        section.dataset.cpgFitmentStatus = status;
        section.dataset.cpgRequiresFitment = nextRequiresFitment ? 'true' : 'false';
        section.dataset.cpgHasVehicle = (status === 'fit' || status === 'not-fit') ? 'true' : 'false';

        var hasVehicle = status === 'fit' || status === 'not-fit';
        var isFit = status === 'fit';
        var isNotFit = status === 'not-fit';
        var isNoData = status === 'no-data';
        var isGateOpen = status === 'universal' || status === 'build-spec' || status === 'unknown'; // not vehicle-keyed → cart always shows, no vehicle-fit banners
        var showMissing = !hasVehicle && !isNoData && !isGateOpen;

        updateVehicleText(hasVehicle ? selectedVehicleText : '');

        setNodeHidden(section.querySelectorAll('[data-cpg-fitment-confirmed]'), !isFit);
        setNodeHidden(section.querySelectorAll('[data-cpg-fitment-not-fit]'), !isNotFit);
        setNodeHidden(section.querySelectorAll('[data-cpg-fitment-missing]'), !showMissing);
        setNodeHidden(section.querySelectorAll('[data-cpg-fitment-no-data]'), !isNoData);

        var fitmentCard = section.querySelector('[data-cpg-fitment-card]');
        var notFitCard = section.querySelector('[data-cpg-not-fit-card]');
        var noFitmentDataCard = section.querySelector('[data-cpg-no-fitment-data-card]');
        var ymmBox = section.querySelector('[data-cpg-ymm-box]');
        var descriptionFitment = section.querySelector('[data-cpg-description-fitment]');
        var descriptionNotFit = section.querySelector('[data-cpg-description-not-fit]');
        var cartFitmentMessage = section.querySelector('[data-cpg-cart-fitment-message]');

        if (fitmentCard) fitmentCard.hidden = true;
        if (notFitCard) notFitCard.hidden = true;
        if (noFitmentDataCard) noFitmentDataCard.hidden = !isNoData;
        if (ymmBox) ymmBox.hidden = false;
        if (descriptionFitment) descriptionFitment.hidden = true;
        if (descriptionNotFit) descriptionNotFit.hidden = !isNotFit;

        section.querySelectorAll('[data-cpg-paired-fit]').forEach(function (node) {
          node.hidden = false;
          node.classList.remove('is-not-fit', 'is-missing', 'is-no-data');

          if (isFit) {
            node.textContent = 'Fits ' + selectedVehicleText;
          } else if (isNotFit) {
            node.classList.add('is-not-fit');
            node.textContent = 'Does not fit ' + selectedVehicleText;
          } else if (isNoData) {
            node.classList.add('is-no-data');
            node.textContent = 'Verify fitment manually';
          } else {
            node.classList.add('is-missing');
            node.textContent = 'No vehicle selected';
          }
        });

        // MOCKUP 2026-10-02: clear the engine prompt on ANY definitive answer (it stayed after a
        // wrong engine was picked, under the red Does Not Fit card).
        if (cartFitmentMessage && status !== 'missing' && status !== 'engine-ask' && /engine/i.test(cartFitmentMessage.textContent || '')) { cartFitmentMessage.hidden = true; cartFitmentMessage.textContent = ''; }
        if (cartFitmentMessage && (isFit || isNoData)) {
          cartFitmentMessageLocked = false;
          cartFitmentMessage.hidden = true;
          cartFitmentMessage.textContent = '';
          cartFitmentMessage.classList.remove('is-error');
        }

        /* CPG 2026-07-23 (owner 2B): hide the purchase UI when the part does NOT
           fit the selected vehicle. The not-fit block (with an explicit
           "I've verified this fits — add anyway" override) shows instead. */
        var cartRow = section.querySelector('.cpg-product__cart-row');
        var notfitBlock = section.querySelector('[data-cpg-notfit-override]');
        var stickyBarEl = document.querySelector('[data-cpg-sticky-bar]');
        var overridden = section.dataset.cpgNotfitOverride === 'true';
        /* CPG 2026-07-30 (owner): FORCE vehicle selection. Until a vehicle is chosen,
           hide the buy UI on EVERY product and show only the choose-vehicle prompt;
           once a vehicle IS selected the fit / not-fit / no-data states take over. */
        var noVehicleChosen = !isVehicleSelected();
        if (noVehicleChosen && !isGateOpen) {
          setNodeHidden(section.querySelectorAll('[data-cpg-fitment-confirmed]'), true);
          setNodeHidden(section.querySelectorAll('[data-cpg-fitment-not-fit]'), true);
          setNodeHidden(section.querySelectorAll('[data-cpg-fitment-no-data]'), true);
          setNodeHidden(section.querySelectorAll('[data-cpg-fitment-missing]'), false);
          if (noFitmentDataCard) noFitmentDataCard.hidden = true;
        }
        var notFitHide = isNotFit && !overridden;
        /* CPG 2026-07-30 (owner): on the blue "no-data" (fit-unverified) state, hide the
           plain Add to Cart and show the "I've verified this fits - add anyway" override
           instead (only once a vehicle is chosen). Mirrors the not-fit buy UI. */
        var unverifiedHide = isNoData && !overridden && !noVehicleChosen;
        /* MOCKUP 2026-10-02 (owner): never block. Add to Cart stays visible in every state; the
           fitment box above it tells the truth and the cart records it. */
        void notFitHide; void unverifiedHide;
        var hideBuy = false;
        if (cartRow) cartRow.hidden = false;
        if (notfitBlock) notfitBlock.hidden = true;
        if (stickyBarEl) stickyBarEl.classList.toggle('cpg-notfit-hidden', hideBuy);
      }

      function readFitmentFromObject(value, depth) {
        if (value === true) return 'fit';
        if (value === false) return 'not-fit';
        if (value === null || value === undefined || depth > 5) return '';

        if (typeof value === 'string') {
          var text = normalizeText(value).toLowerCase();

          if (/^(yes|true|fit|fits|matched|match|compatible|valid)$/i.test(text)) return 'fit';
          if (/^(no|false|not-fit|not_fit|not fit|not matched|incompatible|invalid)$/i.test(text)) return 'not-fit';
          if (/does not fit|not compatible|not fit|won't fit|will not fit/i.test(text)) return 'not-fit';
          if (/fits your vehicle|this product fits|compatible with|will fit/i.test(text)) return 'fit';

          return '';
        }

        if (typeof value !== 'object') return '';

        if (Array.isArray(value)) {
          for (var i = 0; i < value.length; i += 1) {
            var arrayResult = readFitmentFromObject(value[i], depth + 1);
            if (arrayResult) return arrayResult;
          }

          return '';
        }

        var priorityKeys = [
          'fits', 'fit', 'isFit', 'is_fit', 'matched', 'match', 'isMatched', 'isUniversal',
          'compatible', 'isCompatible', 'success', 'result', 'status', 'value', 'message', 'text'
        ];

        for (var p = 0; p < priorityKeys.length; p += 1) {
          if (Object.prototype.hasOwnProperty.call(value, priorityKeys[p])) {
            var priorityResult = readFitmentFromObject(value[priorityKeys[p]], depth + 1);
            if (priorityResult) return priorityResult;
          }
        }

        var keys = Object.keys(value);

        for (var k = 0; k < keys.length; k += 1) {
          var key = keys[k];

          if (/fit|match|compatib|vehicle|ymm|status|result|message/i.test(key)) {
            var result = readFitmentFromObject(value[key], depth + 1);
            if (result) return result;
          }
        }

        return '';
      }

      function readFitmentFromConvermaxDom() {
        var candidates = Array.prototype.slice.call(document.querySelectorAll(
          '.cm_fitment, .cm_fitment-table, .cm_fitment_table, [class*="fitment"], [id*="fitment"], [class*="compatib"], [class*="vehicle-widget"]'
        ));

        for (var i = 0; i < candidates.length; i += 1) {
          var node = candidates[i];
          if (!node || section.contains(node)) continue;

          var text = normalizeText(node.textContent).toLowerCase();
          if (!text) continue;

          if (/does not fit|not compatible|not fit|won't fit|will not fit/.test(text)) return 'not-fit';
          if (/fits your vehicle|this product fits|confirmed fit|compatible with/.test(text)) return 'fit';
        }

        return '';
      }


      function isNodeVisible(node) {
        if (!node || node.hidden) return false;

        try {
          var style = window.getComputedStyle(node);
          if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) {
            return false;
          }
        } catch (error) {}

        return true;
      }

      function getVisibleText(node) {
        if (!node) return '';

        var clone = node.cloneNode(true);

        clone.querySelectorAll('[hidden], script, style, template').forEach(function (hiddenNode) {
          hiddenNode.remove();
        });

        return normalizeText(clone.textContent).toLowerCase();
      }

      function detectProductFitmentDataState() {
        var host = section.querySelector('[data-cpg-fitment-table-host]');
        var searchableNodes = [];

        if (host) searchableNodes.push(host);

        searchableNodes = searchableNodes.concat(Array.prototype.slice.call(document.querySelectorAll(
          '.cm_fitment-table, .cm_fitment_table, .cm_fitment, [class*="fitment-table"], [class*="FitmentTable"]'
        )).filter(function (node) {
          return node && isNodeVisible(node);
        }));

        for (var i = 0; i < searchableNodes.length; i += 1) {
          var text = getVisibleText(searchableNodes[i]);
          if (!text) continue;

          if (/no fitment data|fitment data unavailable|no fitment available|no vehicle fitment|not enough fitment/.test(text)) {
            productFitmentDataState = 'unavailable';
            return productFitmentDataState;
          }

          if (
            (text.indexOf('year') !== -1 && text.indexOf('make') !== -1 && text.indexOf('model') !== -1) ||
            /fits your vehicle|this product fits|does not fit|confirmed fit|compatible with/.test(text)
          ) {
            productFitmentDataState = 'available';
            return productFitmentDataState;
          }
        }

        return productFitmentDataState;
      }

      function resolveFitmentState() {
        if (isResolvingFitment) return Promise.resolve(fitmentStatus);

        isResolvingFitment = true;
        // 2026-09-09: universal / sold-by-spec parts (custom.fitment_status -> data-cpg-gate-open)
        // are not vehicle-keyed. Open the buy gate immediately, no vehicle or fitment verify.
        if (section.dataset.cpgGateOpen) {
          applyFitmentState(section.dataset.cpgGateOpen, '');
          isResolvingFitment = false;
          return Promise.resolve(fitmentStatus);
        }
        detectProductFitmentDataState();
        requiresFitment = productFitmentDataState !== 'unavailable';

        if (!isConvermaxReady()) {
          applyFitmentState(productFitmentDataState === 'unavailable' ? 'no-data' : 'missing', '');
          isResolvingFitment = false;
          return Promise.resolve(fitmentStatus);
        }

        if (!isVehicleSelected()) {
          applyFitmentState(productFitmentDataState === 'unavailable' ? 'no-data' : 'missing', '');
          isResolvingFitment = false;
          return Promise.resolve(fitmentStatus);
        }

        var vehicleText = getSelectedVehicleText();

        if (!vehicleText) {
          applyFitmentState(productFitmentDataState === 'unavailable' ? 'no-data' : 'missing', '');
          isResolvingFitment = false;
          return Promise.resolve(fitmentStatus);
        }

        lastKnownVehicleText = vehicleText;

        var verificationPromise;

        try {
          if (window.CPGFitment && typeof window.CPGFitment.verify === 'function') {
            // CPG teardown: authoritative verify against our own fitment API.
            verificationPromise = window.CPGFitment.verify(getConvermaxProductId());
          } else if (window.Convermax && typeof window.Convermax.verifyFitmentAsync === 'function') {
            verificationPromise = window.Convermax.verifyFitmentAsync(getConvermaxProductId());
          } else {
            verificationPromise = Promise.resolve(readFitmentFromConvermaxDom());
          }
        } catch (error) {
          verificationPromise = Promise.resolve(readFitmentFromConvermaxDom());
        }

        return Promise.resolve(verificationPromise)
          .then(function (result) {
            removeEngineAsk();
            // CPG verify returns final statuses directly — honor them before the
            // permissive legacy parsing (whose unknown-default is 'fit').
            if (result === 'fit-check-engine') {
              // Fits ONLY specific engines and the vehicle has none saved —
              // ask the one contextual question instead of overclaiming a fit.
              productFitmentDataState = 'available';
              renderEngineAsk(vehicleText);
              return 'fit-check-engine';
            }
            if (result === 'universal') {
              productFitmentDataState = 'available';
              applyFitmentState('universal', vehicleText);
              return 'universal';
            }
            if (result === 'build-spec') {
              productFitmentDataState = 'available';
              applyFitmentState('build-spec', vehicleText);
              return 'build-spec';
            }
            if (result === 'no-data') {
              productFitmentDataState = 'unavailable';
              applyFitmentState('no-data', vehicleText);
              return 'no-data';
            }
            if (result === 'error') {
              // Could not verify — stay neutral rather than claiming a fit.
              applyFitmentState('missing', '');
              return 'missing';
            }
            var parsedResult = readFitmentFromObject(result, 0) || readFitmentFromConvermaxDom();
            detectProductFitmentDataState();

            if (parsedResult === 'fit') {
              productFitmentDataState = 'available';
              applyFitmentState('fit', vehicleText);
              return 'fit';
            }

            if (parsedResult === 'not-fit') {
              productFitmentDataState = 'available';
              applyFitmentState('not-fit', vehicleText);
              return 'not-fit';
            }

            if (productFitmentDataState === 'unavailable') {
              applyFitmentState('no-data', vehicleText);
              return 'no-data';
            }

            applyFitmentState('fit', vehicleText);
            return 'fit';
          })
          .catch(function () {
            var domResult = readFitmentFromConvermaxDom();
            detectProductFitmentDataState();

            if (domResult === 'fit') {
              productFitmentDataState = 'available';
              applyFitmentState('fit', vehicleText);
              return 'fit';
            }

            if (domResult === 'not-fit') {
              productFitmentDataState = 'available';
              applyFitmentState('not-fit', vehicleText);
              return 'not-fit';
            }

            if (productFitmentDataState === 'unavailable') {
              applyFitmentState('no-data', vehicleText);
              return 'no-data';
            }

            applyFitmentState('fit', vehicleText);
            return 'fit';
          })
          .finally(function () {
            isResolvingFitment = false;
          });
      }

      function removeEngineAsk() {
        section.querySelectorAll('[data-cpg-engine-ask]').forEach(function (el) { el.remove(); });
      }

      /** Contextual engine-ask (PDP-only, owner rule): the product fits the
       *  saved Y/M/M but only for specific engines. Renders an amber prompt
       *  with just those engine options; picking one saves the engine on the
       *  garage vehicle, which re-fires verification for a definitive answer. */
      function renderEngineAsk(vehicleText) {
        var ask = window.CPGFitment && window.CPGFitment.engineAsk;
        var options = ask && ask.options ? ask.options : [];
        if (!options.length) { applyFitmentState('fit', vehicleText); return; }

        // Reuse the standard state pipeline (shows the vehicle row + picker box,
        // hides fit/not-fit cards), then mount a dedicated ask card ABOVE the
        // YMM box in the main buy area. Never mount on [data-cpg-paired-fit] —
        // those nodes live inside paired-product card links, so a click there
        // would also follow the link.
        applyFitmentState('missing', '');
        lastAppliedFitmentKey = 'engine-ask|' + vehicleText; // unkey so the next real state applies
        section.dataset.cpgFitmentStatus = 'engine-ask';
        updateVehicleText(vehicleText);
        setNodeHidden(section.querySelectorAll('[data-cpg-fitment-missing]'), true);

        var ymmBox = section.querySelector('[data-cpg-ymm-box]');
        var anchor = ymmBox || section.querySelector('[data-cpg-fitment-confirmed]');
        if (!anchor || !anchor.parentNode) return;

        var box = document.createElement('div');
        box.setAttribute('data-cpg-engine-ask', '');
        box.className = 'cpg-engine-ask';
        var label = document.createElement('p');
        label.className = 'cpg-engine-ask__label';
        label.textContent = 'Fits specific engines of your ' + vehicleText + '. Which engine do you have?';
        box.appendChild(label);
        var row = document.createElement('div');
        row.className = 'cpg-engine-ask__row';
        options.forEach(function (opt) {
          // Option B: opt is { value, fits } (every engine the car came with). Tolerate a legacy
          // string. List them ALL — do not hide the non-fitting ones; picking one re-resolves to the
          // honest answer (green fits, or red "does not fit" + a route to the parts that do).
          var val = (opt && typeof opt === 'object') ? opt.value : opt;
          if (!val) return;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cpg-engine-ask__btn';
          b.textContent = val;
          b.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (window.CPGFitment && window.CPGFitment.setEngine) window.CPGFitment.setEngine(val);
          });
          row.appendChild(b);
        });
        box.appendChild(row);
        anchor.parentNode.insertBefore(box, anchor);
        if (ymmBox) ymmBox.hidden = true; // the ask IS the picker for this state

        // Option B (owner 2026-08-18): LOCK add-to-cart while the engine is unanswered
        // (NEEDS_QUALIFIER). Picking an engine re-resolves via cpg:vehicle-changed -> a definitive
        // FITS (cart restored) or NO_FIT (cart stays hidden, "see the parts that fit" shown).
        var cartRowEl = section.querySelector('.cpg-product__cart-row');
        var stickyEl = document.querySelector('[data-cpg-sticky-bar]');
        // MOCKUP: engine question no longer hides the buy button.
        void cartRowEl; void stickyEl;
        var cartMsg = section.querySelector('[data-cpg-cart-fitment-message]');
        if (cartMsg) { cartMsg.hidden = false; cartMsg.textContent = 'Select your engine above to confirm the fit. You can still add it to your cart.'; }

        if (!document.getElementById('cpg-engine-ask-css')) {
          var style = document.createElement('style');
          style.id = 'cpg-engine-ask-css';
          style.textContent =
            '.cpg-engine-ask{margin:10px 0;padding:14px 16px;border:1px solid #f0c36d;background:#fffbeb;border-radius:10px}' +
            '.cpg-engine-ask__label{margin:0 0 10px;color:#92400e;font-size:13.5px;font-weight:700}' +
            '.cpg-engine-ask__row{display:flex;flex-wrap:wrap;gap:8px}' +
            '.cpg-engine-ask__btn{border:1px solid #d97706;background:#fff;color:#92400e;border-radius:8px;padding:8px 14px;font-size:13px;font-weight:700;cursor:pointer}' +
            '.cpg-engine-ask__btn:hover{background:#d97706;color:#fff}';
          document.head.appendChild(style);
        }
      }

      function scheduleFitmentResolve(delay) {
        window.clearTimeout(fitmentResolveTimer);

        fitmentResolveTimer = window.setTimeout(function () {
          syncConvermaxFitmentTable();
          resolveFitmentState();
        }, delay || 250);
      }

      // CPG teardown: the YMM widget announces garage changes — re-resolve
      // immediately (the storage poller would catch it anyway, this is snappier).
      window.addEventListener('cpg:vehicle-changed', function () {
        lastAppliedFitmentKey = '';
        scheduleFitmentResolve(0);
      });

      function getNextNonSundayDate(daysToAdd) {
        var date = new Date();
        date.setDate(date.getDate() + daysToAdd);

        while (date.getDay() === 0) {
          date.setDate(date.getDate() + 1);
        }

        return date;
      }

      function formatShippingDate(date) {
        return date.toLocaleDateString('en-US', {
          weekday: 'short',
          month: 'short',
          day: 'numeric'
        });
      }

      function setShippingDates() {
        var startDate = getNextNonSundayDate(3);
        var endDate = getNextNonSundayDate(4);

        if (endDate <= startDate) {
          endDate = new Date(startDate);
          endDate.setDate(endDate.getDate() + 1);

          while (endDate.getDay() === 0) {
            endDate.setDate(endDate.getDate() + 1);
          }
        }

        section.querySelectorAll('[data-cpg-ship-start]').forEach(function (node) {
          node.textContent = formatShippingDate(startDate);
        });

        section.querySelectorAll('[data-cpg-ship-end]').forEach(function (node) {
          node.textContent = formatShippingDate(endDate);
        });
      }

      function syncConvermaxFitmentTable() {
        var host = section.querySelector('[data-cpg-fitment-table-host]');
        if (!host) return;

        var candidates = Array.prototype.slice.call(document.querySelectorAll(
          '.cm_fitment-table, .cm_fitment_table, .cm_fitment, [class*="fitment-table"], [class*="FitmentTable"], table'
        ));

        var bestTable = null;

        candidates.some(function (candidate) {
          if (!candidate || section.contains(candidate)) return false;

          var text = normalizeText(candidate.textContent).toLowerCase();

          if (
            text.indexOf('year') !== -1 &&
            text.indexOf('make') !== -1 &&
            text.indexOf('model') !== -1 &&
            (text.indexOf('submodel') !== -1 || text.indexOf('trim') !== -1 || text.indexOf('engine') !== -1)
          ) {
            bestTable = candidate;
            return true;
          }

          return false;
        });

        if (!bestTable) {
          detectProductFitmentDataState();
          return;
        }

        productFitmentDataState = 'available';
        host.innerHTML = '';
        host.appendChild(bestTable.cloneNode(true));
      }

      /* initPairedSwiper() removed 2026-08-01. Swiper was dropped from this template — the
         "Frequently Paired With" rail is now a native CSS scroll-snap rail, and its prev/next
         arrows are wired in product_template.liquid (wirePairedArrows). The function was already
         inert after that change (it returned early on `typeof Swiper === 'undefined'`), but it
         was still being called three times per page, including timers at 600ms and 1600ms. */

      function openGarage() {
        // The reliable path: open the CPGFitment modal picker directly. The old
        // approach (click the header garage trigger) silently failed when that
        // element wasn't present/bound on the page — which is why "Change" did nothing.
        if (window.CPGFitment && typeof window.CPGFitment.openPicker === 'function') {
          window.CPGFitment.openPicker();
          return;
        }

        var ymmBox = section.querySelector('[data-cpg-ymm-box]');
        if (ymmBox) {
          ymmBox.hidden = false;
          ymmBox.setAttribute('aria-hidden', 'false');
          ymmBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        var headerGarageTrigger =
          document.getElementById('cpGarageTriggerDesktop') ||
          document.getElementById('cpGarageTrigger');
        if (headerGarageTrigger) {
          headerGarageTrigger.click();
        }
      }

      var currentMediaIndex = 0;

      function getMediaSlideCount() {
        return section.querySelectorAll('[data-cpg-slide]').length;
      }

      function showSlide(index) {
        var totalSlides = getMediaSlideCount();
        var nextIndex = Number(index);

        if (!Number.isFinite(nextIndex)) nextIndex = 0;
        if (totalSlides > 0) {
          nextIndex = ((nextIndex % totalSlides) + totalSlides) % totalSlides;
        }

        currentMediaIndex = nextIndex;

        section.querySelectorAll('[data-cpg-slide]').forEach(function (slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-cpg-slide') === String(nextIndex));
        });

        section.querySelectorAll('[data-cpg-thumb]').forEach(function (thumb) {
          thumb.classList.toggle('is-active', thumb.getAttribute('data-cpg-thumb') === String(nextIndex));
        });

        section.querySelectorAll('[data-cpg-dot]').forEach(function (dot) {
          dot.classList.toggle('is-active', dot.getAttribute('data-cpg-dot') === String(nextIndex));
        });
      }

      function setupMobileMediaSwipe() {
        var mediaMain = section.querySelector('.cpg-product__media-main');
        if (!mediaMain || getMediaSlideCount() < 2 || mediaMain.hasAttribute('data-cpg-swipe-ready')) return;

        mediaMain.setAttribute('data-cpg-swipe-ready', 'true');

        var startX = 0;
        var startY = 0;
        var startTime = 0;
        var isTracking = false;
        var lockedDirection = null;

        function shouldIgnoreSwipe(target) {
          return Boolean(target && target.closest && target.closest('button, a, input, select, textarea, video, iframe'));
        }

        function getPoint(event) {
          if (event.touches && event.touches.length) {
            return {
              x: event.touches[0].clientX,
              y: event.touches[0].clientY
            };
          }

          if (event.changedTouches && event.changedTouches.length) {
            return {
              x: event.changedTouches[0].clientX,
              y: event.changedTouches[0].clientY
            };
          }

          return {
            x: event.clientX,
            y: event.clientY
          };
        }

        function startSwipe(event) {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          if (shouldIgnoreSwipe(event.target)) return;

          var point = getPoint(event);

          isTracking = true;
          lockedDirection = null;
          startX = point.x;
          startY = point.y;
          startTime = Date.now();
        }

        function moveSwipe(event) {
          if (!isTracking) return;

          var point = getPoint(event);
          var deltaX = point.x - startX;
          var deltaY = point.y - startY;
          var absX = Math.abs(deltaX);
          var absY = Math.abs(deltaY);

          if (!lockedDirection && (absX > 8 || absY > 8)) {
            lockedDirection = absX > absY * 1.2 ? 'horizontal' : 'vertical';
          }

          if (lockedDirection === 'vertical') {
            isTracking = false;
            return;
          }

          if (lockedDirection === 'horizontal' && event.cancelable) {
            event.preventDefault();
          }
        }

        function endSwipe(event) {
          if (!isTracking) return;

          var point = getPoint(event);
          var deltaX = point.x - startX;
          var deltaY = point.y - startY;
          var elapsed = Date.now() - startTime;

          isTracking = false;

          if (lockedDirection !== 'horizontal') return;
          if (Math.abs(deltaX) < 35) return;
          if (Math.abs(deltaX) < Math.abs(deltaY) * 1.15) return;
          if (elapsed > 900) return;

          showSlide(currentMediaIndex + (deltaX < 0 ? 1 : -1));
        }

        function cancelSwipe() {
          isTracking = false;
          lockedDirection = null;
        }

        mediaMain.addEventListener('pointerdown', startSwipe, { passive: true });
        mediaMain.addEventListener('pointermove', moveSwipe, { passive: false });
        mediaMain.addEventListener('pointerup', endSwipe, { passive: true });
        mediaMain.addEventListener('pointercancel', cancelSwipe, { passive: true });
        mediaMain.addEventListener('lostpointercapture', cancelSwipe, { passive: true });

        mediaMain.addEventListener('touchstart', startSwipe, { passive: true });
        mediaMain.addEventListener('touchmove', moveSwipe, { passive: false });
        mediaMain.addEventListener('touchend', endSwipe, { passive: true });
        mediaMain.addEventListener('touchcancel', cancelSwipe, { passive: true });
      }



      function setupImageZoom() {
        var zoomButton = section.querySelector('[data-cpg-zoom-open]');
        var modal = section.querySelector('[data-cpg-zoom-modal]');
        var stage = section.querySelector('[data-cpg-zoom-stage]');
        var count = section.querySelector('[data-cpg-zoom-count]');
        var zoomIndex = currentMediaIndex || 0;

        if (!zoomButton || !modal || modal.hasAttribute('data-cpg-zoom-ready')) return;
        modal.setAttribute('data-cpg-zoom-ready', 'true');


        function getZoomSlideCount() {
          return modal.querySelectorAll('[data-cpg-zoom-slide]').length;
        }

        function showZoomSlide(index) {
          var total = getZoomSlideCount();
          var nextIndex = Number(index);

          if (!Number.isFinite(nextIndex)) nextIndex = 0;
          if (total > 0) {
            nextIndex = ((nextIndex % total) + total) % total;
          }

          zoomIndex = nextIndex;

          modal.querySelectorAll('[data-cpg-zoom-slide]').forEach(function (slide) {
            slide.classList.toggle('is-active', slide.getAttribute('data-cpg-zoom-slide') === String(nextIndex));
          });

          if (count && total > 1) {
            count.textContent = (nextIndex + 1) + ' / ' + total;
          }
        }

        function openZoom() {
          zoomIndex = currentMediaIndex || 0;
          showZoomSlide(zoomIndex);
          modal.hidden = false;
          modal.removeAttribute('hidden');
          modal.setAttribute('aria-hidden', 'false');
        }

        function closeZoom() {
          modal.hidden = true;
          modal.setAttribute('hidden', 'hidden');
          modal.setAttribute('aria-hidden', 'true');
        }

        zoomButton.addEventListener('click', function (event) {
          event.preventDefault();
          openZoom();
        });

        modal.querySelectorAll('[data-cpg-zoom-close]').forEach(function (button) {
          button.addEventListener('click', function (event) {
            event.preventDefault();
            closeZoom();
          });
        });

        var prevButton = modal.querySelector('[data-cpg-zoom-prev]');
        var nextButton = modal.querySelector('[data-cpg-zoom-next]');

        if (prevButton) {
          prevButton.addEventListener('click', function () {
            showZoomSlide(zoomIndex - 1);
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', function () {
            showZoomSlide(zoomIndex + 1);
          });
        }

        document.addEventListener('keydown', function (event) {
          if (modal.hidden) return;

          if (event.key === 'Escape') closeZoom();
          if (event.key === 'ArrowLeft') showZoomSlide(zoomIndex - 1);
          if (event.key === 'ArrowRight') showZoomSlide(zoomIndex + 1);
        });

        if (stage && getZoomSlideCount() > 1) {
          var startX = 0;
          var startY = 0;
          var startTime = 0;
          var isTracking = false;
          var lockedDirection = null;

          function getPoint(event) {
            if (event.touches && event.touches.length) {
              return { x: event.touches[0].clientX, y: event.touches[0].clientY };
            }

            if (event.changedTouches && event.changedTouches.length) {
              return { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
            }

            return { x: event.clientX, y: event.clientY };
          }

          function startZoomSwipe(event) {
            if (event.pointerType === 'mouse' && event.button !== 0) return;
            var point = getPoint(event);
            isTracking = true;
            lockedDirection = null;
            startX = point.x;
            startY = point.y;
            startTime = Date.now();
          }

          function moveZoomSwipe(event) {
            if (!isTracking) return;

            var point = getPoint(event);
            var deltaX = point.x - startX;
            var deltaY = point.y - startY;
            var absX = Math.abs(deltaX);
            var absY = Math.abs(deltaY);

            if (!lockedDirection && (absX > 8 || absY > 8)) {
              lockedDirection = absX > absY * 1.2 ? 'horizontal' : 'vertical';
            }

            if (lockedDirection === 'horizontal' && event.cancelable) {
              event.preventDefault();
            }
          }

          function endZoomSwipe(event) {
            if (!isTracking) return;

            var point = getPoint(event);
            var deltaX = point.x - startX;
            var deltaY = point.y - startY;
            var elapsed = Date.now() - startTime;

            isTracking = false;

            if (lockedDirection !== 'horizontal') return;
            if (Math.abs(deltaX) < 35) return;
            if (Math.abs(deltaX) < Math.abs(deltaY) * 1.15) return;
            if (elapsed > 900) return;

            showZoomSlide(zoomIndex + (deltaX < 0 ? 1 : -1));
          }

          function cancelZoomSwipe() {
            isTracking = false;
            lockedDirection = null;
          }

          stage.addEventListener('pointerdown', startZoomSwipe, { passive: true });
          stage.addEventListener('pointermove', moveZoomSwipe, { passive: false });
          stage.addEventListener('pointerup', endZoomSwipe, { passive: true });
          stage.addEventListener('pointercancel', cancelZoomSwipe, { passive: true });
          stage.addEventListener('touchstart', startZoomSwipe, { passive: true });
          stage.addEventListener('touchmove', moveZoomSwipe, { passive: false });
          stage.addEventListener('touchend', endZoomSwipe, { passive: true });
          stage.addEventListener('touchcancel', cancelZoomSwipe, { passive: true });
        }
      }

      function getInventoryStockState(variant) {
        var qty = Number(variant && variant.inventory_quantity);

        if (!Number.isFinite(qty)) qty = 0;

        if (qty <= 0) {
          return {
            state: 'unavailable',
            text: 'Out of Stock',
            badgeText: 'Out of Stock',
            shippingText: 'Out of Stock',
            buttonText: 'Add to Cart',
            popupTitle: 'Out of Stock',
            popupIntro: 'Fill the form and our team will notify you when this product is back in stock.',
            requestType: 'Out of Stock',
            message: 'This product is currently out of stock. It will be placed on backorder, and shipping can take 2 or more weeks to fulfill your order. <button type="button" class="cpg-product__availability-link" data-cpg-availability-open>Fill the Form</button> and we will notify you as soon as it is back in stock.'
          };
        }

        if (qty === 1) {
          return {
            state: 'instock',
            text: 'Only 1 left, order now',
            badgeText: 'Only 1 Left',
            shippingText: 'Only 1 left, order now',
            buttonText: 'Add to Cart',
            message: ''
          };
        }

        return {
          state: 'instock',
          text: 'In Stock · Fast Shipping',
          badgeText: 'In Stock',
          shippingText: 'In Stock · Fast Shipping',
          buttonText: 'Add to Cart',
          message: ''
        };
      }


      function getCurrentVariant() {
        var currentId = variantInput ? String(variantInput.value || '') : '';
        return variants.find(function (variant) { return String(variant.id) === currentId; }) || variants[0] || null;
      }

      function openAvailabilityPopup(variant, stockState) {
        var popup = section.querySelector('[data-cpg-availability-popup]');
        if (!popup) return;

        var productTitle = window.CPG_PT_DATA.productTitle;
        var variantTitle = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
        var sku = variant && variant.sku ? variant.sku : window.CPG_PT_DATA.currentVariantSku;
        var displayProduct = productTitle + (variantTitle ? ' - ' + variantTitle : '');
        var currentStockState = stockState || getInventoryStockState(variant);
        var requestType = currentStockState.requestType || currentStockState.buttonText || 'Product Availability Request';

        var title = popup.querySelector('[data-cpg-availability-title]');
        var intro = popup.querySelector('[data-cpg-availability-intro]');
        var productDisplay = popup.querySelector('[data-cpg-availability-product-display]');
        var productInput = popup.querySelector('[data-cpg-availability-product-input]');
        var variantInputPopup = popup.querySelector('[data-cpg-availability-variant-input]');
        var skuInput = popup.querySelector('[data-cpg-availability-sku-input]');
        var typeInput = popup.querySelector('[data-cpg-availability-type-input]');
        var message = popup.querySelector('[data-cpg-availability-message]');

        if (title) title.textContent = currentStockState.popupTitle || requestType;
        if (intro) intro.textContent = currentStockState.popupIntro || 'Fill the form and our team will contact you.';
        if (productDisplay) productDisplay.value = displayProduct;
        if (productInput) productInput.value = productTitle;
        if (variantInputPopup) variantInputPopup.value = variantTitle || 'Default Title';
        if (skuInput) skuInput.value = sku || '';
        if (typeInput) typeInput.value = requestType;
        if (message) {
          message.value = 'I would like to ' + requestType.toLowerCase() + ' for ' + displayProduct + (sku ? ' (SKU: ' + sku + ')' : '') + '.';
        }

        popup.hidden = false;
        document.documentElement.classList.add('cpg-availability-popup-open');
        var firstInput = popup.querySelector('input[name="contact[name]"]');
        if (firstInput) window.setTimeout(function () { firstInput.focus(); }, 50);
      }

      function closeAvailabilityPopup() {
        var popup = section.querySelector('[data-cpg-availability-popup]');
        if (!popup) return;
        popup.hidden = true;
        document.documentElement.classList.remove('cpg-availability-popup-open');
      }

      function updateStockAndButton(variant) {
        var stockState = getInventoryStockState(variant);
        var stockRow = section.querySelector('[data-cpg-stock-row]');
        var stockText = section.querySelector('[data-cpg-stock-text]');
        var stockBadge = section.querySelector('[data-cpg-stock-badge]');
        var shippingStatus = section.querySelector('[data-cpg-shipping-status]');
        var shippingTabStatus = section.querySelector('[data-cpg-shipping-tab-status]');
        var backorderMessage = section.querySelector('[data-cpg-backorder-message]');

        if (stockRow) {
          stockRow.classList.remove('is-backorder', 'is-contact', 'is-instock', 'is-unavailable');
          stockRow.classList.add('is-' + stockState.state);
        }

        if (stockText) stockText.textContent = stockState.text;

        if (stockBadge) {
          stockBadge.classList.remove(
            'cpg-product__badge--stock-backorder',
            'cpg-product__badge--stock-contact',
            'cpg-product__badge--stock-instock',
            'cpg-product__badge--stock-unavailable'
          );
          stockBadge.classList.add('cpg-product__badge--stock-' + stockState.state);
          stockBadge.textContent = stockState.badgeText;
        }

        if (shippingStatus) shippingStatus.textContent = stockState.shippingText;
        if (shippingTabStatus) shippingTabStatus.textContent = stockState.shippingText;

        if (backorderMessage) {
          backorderMessage.innerHTML = stockState.message || '';
          backorderMessage.hidden = !(stockState.state === 'unavailable' || stockState.state === 'contact');
        }

        [addButton, stickyAdd].forEach(function (button) {
          if (!button) return;
          button.disabled = false;
          button.setAttribute('aria-disabled', 'false');
          button.setAttribute('data-cpg-stock-action', 'add-to-cart');
          button.classList.remove(
            'cpg-product__add--backorder',
            'cpg-product__add--contact',
            'cpg-product__add--instock',
            'cpg-product__add--unavailable',
            'cpg-product__sticky-add--backorder',
            'cpg-product__sticky-add--contact',
            'cpg-product__sticky-add--instock',
            'cpg-product__sticky-add--unavailable'
          );
          if (button.classList.contains('cpg-product__add')) {
            button.classList.add('cpg-product__add--' + stockState.state);
            var addText = button.querySelector('span');
            if (addText) addText.textContent = 'Add to Cart';
          } else {
            button.classList.add('cpg-product__sticky-add--' + stockState.state);
            var stickyTextNodes = Array.prototype.filter.call(button.childNodes, function (node) { return node.nodeType === 3 && node.textContent.trim(); });
            if (stickyTextNodes[0]) stickyTextNodes[0].textContent = ' Add to Cart';
          }
        });
      }

      function updateVariant() {
        var selected = [];

        section.querySelectorAll('.cpg-product__option').forEach(function (field) {
          var active = field.querySelector('.cpg-product__option-btn.is-active');
          selected.push(active ? active.getAttribute('data-cpg-option-value') : '');
        });

        var matchedVariant = variants.find(function (variant) {
          return variant.options.every(function (optionValue, index) {
            return optionValue === selected[index];
          });
        });

        if (!matchedVariant) return;

        if (variantInput) variantInput.value = matchedVariant.id;

        var priceNode = section.querySelector('[data-cpg-price]');
        var stickyPrice = section.querySelector('[data-cpg-sticky-price]');

        if (priceNode) priceNode.textContent = formatMoney(matchedVariant.price);
        if (stickyPrice) stickyPrice.textContent = formatMoney(matchedVariant.price);

        updateStockAndButton(matchedVariant);
      }

      function blockCartBecauseFitment(event) {
        /* Fitment should never block ordering.
           Keep the fitment UI/messages visible, but always allow Add to Cart. */
        var cartFitmentMessage = section.querySelector('[data-cpg-cart-fitment-message]');

        cartFitmentMessageLocked = false;

        if (cartFitmentMessage) {
          cartFitmentMessage.hidden = true;
          cartFitmentMessage.textContent = '';
          cartFitmentMessage.classList.remove('is-error');
        }

        return false;
      }

      function setupVehicleChangeDetection() {
        var eventNames = [
          'vehicleSelected',
          'vehicleChanged',
          'vehicleDiscarded',
          'garageChanged',
          'fitmentChanged',
          'convermax:vehicle-selected',
          'convermax:vehicle-changed',
          'convermax:vehicle-discarded',
          'convermax:garage-changed'
        ];

        eventNames.forEach(function (eventName) {
          document.addEventListener(eventName, function () {
            lastAppliedFitmentKey = '';
            scheduleFitmentResolve(100);
            scheduleFitmentResolve(700);
          });
        });

        document.addEventListener('cpgApiFitmentStateChanged', function (event) {
          var detail = event && event.detail ? event.detail : {};

          if (detail.sectionId && detail.sectionId !== section.id) return;

          var apiState = detail.fitmentState || '';
          var apiVehicleText = normalizeText(detail.vehicleText || detail.vehicle || '');

          lastAppliedFitmentKey = '';

          if (apiState === 'no_vehicle') {
            applyFitmentState(productFitmentDataState === 'unavailable' ? 'no-data' : 'missing', '');
            scheduleFitmentResolve(700);
            return;
          }

          if (apiState === 'no_fit') {
            applyFitmentState('not-fit', apiVehicleText || getSelectedVehicleText());
            return;
          }

          if (apiState === 'confirmed' || apiState === 'likely_fits' || apiState === 'universal') {
            applyFitmentState('fit', apiVehicleText || getSelectedVehicleText());
            return;
          }

          scheduleFitmentResolve(100);
          scheduleFitmentResolve(700);
        });

        document.addEventListener('click', function (event) {
          if (event.target.closest('[data-cpg-open-garage], [data-cpg-ymm-box], #cm-garage, .cm_garageDropdown, .cm_vehicle-widget, .cm_button, .cm-btn, [data-cm-role]')) {
            lastAppliedFitmentKey = '';
            scheduleFitmentResolve(250);
            window.setTimeout(function () { scheduleFitmentResolve(0); }, 900);
            window.setTimeout(function () { scheduleFitmentResolve(0); }, 1800);
          }
        }, true);

        document.addEventListener('change', function (event) {
          if (event.target.closest('[data-cpg-ymm-box], #cm-garage, .cm_vehicle-widget')) {
            lastAppliedFitmentKey = '';
            scheduleFitmentResolve(400);
          }
        }, true);

        window.addEventListener('storage', function () {
          lastAppliedFitmentKey = '';
          scheduleFitmentResolve(100);
        });

        window.setInterval(function () {
          var nextSignature = getVehicleSignature();

          if (nextSignature !== lastVehicleSignature) {
            lastVehicleSignature = nextSignature;
            lastAppliedFitmentKey = '';
            scheduleFitmentResolve(0);
          }
        }, 1000);

        if (window.MutationObserver) {
          var observeTargets = [section.querySelector('[data-cpg-ymm-box]'), section.querySelector('#cm-ymm'), section.querySelector('[data-cpg-fitment-table-host]')].filter(Boolean);

          observeTargets.forEach(function (target) {
            var observer = new MutationObserver(function () {
              lastAppliedFitmentKey = '';
              scheduleFitmentResolve(650);
            });

            observer.observe(target, {
              childList: true,
              subtree: true,
              characterData: true,
              attributes: true,
              attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'data-vehicle', 'data-fitment']
            });
          });
        }
      }



      function setupMarketReload() {
        document.addEventListener('change', function (event) {
          var target = event.target;
          if (!target) return;

          if (
            target.matches('select[name*="country"], select[name*="currency"], select[name*="locale"], select[id*="Country"], select[id*="Currency"], select[class*="currency"], select[class*="country"]')
          ) {
            window.setTimeout(function () {
              window.location.reload();
            }, 450);
          }
        }, true);

        document.addEventListener('click', function (event) {
          var target = event.target.closest('[data-currency], [data-country], [class*="currency"] button, [class*="country"] button, [class*="localization"] button');
          if (!target) return;

          window.setTimeout(function () {
            var active = document.activeElement;
            if (!active || active.tagName !== 'SELECT') {
              window.location.reload();
            }
          }, 900);
        }, true);
      }

      section.querySelectorAll('[data-cpg-thumb], [data-cpg-dot]').forEach(function (button) {
        button.addEventListener('click', function () {
          showSlide(button.getAttribute('data-cpg-thumb') || button.getAttribute('data-cpg-dot'));
        });
      });

      setupMobileMediaSwipe();
      setupImageZoom();

      section.querySelectorAll('[data-cpg-option-value]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.classList.contains('is-disabled')) return;

          var position = button.getAttribute('data-cpg-option-position');
          var value = button.getAttribute('data-cpg-option-value');

          section.querySelectorAll('[data-cpg-option-position="' + position + '"]').forEach(function (item) {
            item.classList.remove('is-active');
          });

          button.classList.add('is-active');

          var optionLabels = section.querySelectorAll('[data-cpg-selected-option]');

          if (optionLabels[Number(position) - 1]) {
            optionLabels[Number(position) - 1].textContent = value;
          }

          updateVariant();
        });
      });

      section.querySelectorAll('[data-cpg-qty-minus]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!qtyInput) return;
          qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1);
        });
      });

      section.querySelectorAll('[data-cpg-qty-plus]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!qtyInput) return;
          qtyInput.value = Number(qtyInput.value || 1) + 1;
        });
      });

      section.querySelectorAll('[data-cpg-open-garage]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          openGarage();
        });
      });

      section.querySelectorAll('[data-cpg-tab]').forEach(function (tabButton) {
        tabButton.addEventListener('click', function () {
          var tab = tabButton.getAttribute('data-cpg-tab');

          section.querySelectorAll('[data-cpg-tab]').forEach(function (item) {
            item.classList.toggle('is-active', item === tabButton);
            /* role="tab" requires aria-selected to track the active tab; without this the
               markup would satisfy the audit but mislead screen readers after a switch. */
            item.setAttribute('aria-selected', item === tabButton ? 'true' : 'false');
          });

          section.querySelectorAll('[data-cpg-panel]').forEach(function (panel) {
            panel.classList.toggle('is-active', panel.getAttribute('data-cpg-panel') === tab);
          });
        });
      });

      section.querySelectorAll('[data-cpg-tab-open]').forEach(function (button) {
        button.addEventListener('click', function () {
          var tab = button.getAttribute('data-cpg-tab-open');
          var tabButton = section.querySelector('[data-cpg-tab="' + tab + '"]');

          if (tabButton) {
            tabButton.click();
            section.querySelector('.cpg-product__tabs').scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      var productForm = section.querySelector('.cpg-product__form');

      if (productForm) {
        productForm.addEventListener('submit', function (event) {
          if (blockCartBecauseFitment(event)) return;
        }, true);
      }

      if (addButton) {
        addButton.addEventListener('click', function (event) {
          blockCartBecauseFitment(event);
        }, true);
      }

      if (stickyAdd && addButton) {
        stickyAdd.addEventListener('click', function (event) {
          if (blockCartBecauseFitment(event)) return;
          addButton.click();
        });
      }

      section.addEventListener('click', function (event) {
        var openTrigger = event.target.closest('[data-cpg-availability-open]');
        var closeTrigger = event.target.closest('[data-cpg-availability-close]');

        if (openTrigger) {
          event.preventDefault();
          openAvailabilityPopup(getCurrentVariant(), getInventoryStockState(getCurrentVariant()));
        }

        if (closeTrigger) {
          event.preventDefault();
          closeAvailabilityPopup();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeAvailabilityPopup();
      });

      section.querySelectorAll('[data-pqa-section]').forEach(function (qaSection) {
        var popup = qaSection.querySelector('[data-pqa-popup]');
        var openButtons = qaSection.querySelectorAll('[data-pqa-open]');
        var closeButton = qaSection.querySelector('[data-pqa-close]');
        var searchInput = qaSection.querySelector('[data-pqa-search]');
        var sortSelect = qaSection.querySelector('[data-pqa-sort]');
        var list = qaSection.querySelector('[data-pqa-list]');
        var items = Array.from(qaSection.querySelectorAll('[data-pqa-item]'));
        var count = qaSection.querySelector('[data-pqa-count]');
        var empty = qaSection.querySelector('[data-pqa-empty]');

        function updateCount() {
          var visibleItems = items.filter(function (item) {
            return item.style.display !== 'none';
          });

          if (count) {
            count.textContent = visibleItems.length
              ? '1 - ' + visibleItems.length + ' of ' + visibleItems.length + ' Question' + (visibleItems.length > 1 ? 's' : '')
              : '0 Questions';
          }

          if (empty) empty.style.display = visibleItems.length ? 'none' : '';
        }

        updateCount();

        openButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            if (popup) popup.classList.add('active');
          });
        });

        if (closeButton && popup) {
          closeButton.addEventListener('click', function () {
            popup.classList.remove('active');
          });
        }

        if (popup) {
          popup.addEventListener('click', function (event) {
            if (event.target === popup) popup.classList.remove('active');
          });
        }

        if (searchInput) {
          searchInput.addEventListener('input', function () {
            var searchValue = searchInput.value.toLowerCase().trim();

            items.forEach(function (item) {
              var itemText = item.getAttribute('data-search').toLowerCase();
              item.style.display = itemText.includes(searchValue) ? '' : 'none';
            });

            updateCount();
          });
        }

        if (sortSelect && list) {
          sortSelect.addEventListener('change', function () {
            var sortedItems = items.slice().sort(function (a, b) {
              var firstIndex = Number(a.getAttribute('data-index'));
              var secondIndex = Number(b.getAttribute('data-index'));

              return sortSelect.value === 'oldest'
                ? firstIndex - secondIndex
                : secondIndex - firstIndex;
            });

            sortedItems.forEach(function (item) {
              list.appendChild(item);
            });
          });
        }
      });

      setupVehicleChangeDetection();
      setupMarketReload();
      setShippingDates();
      updateStockAndButton(getCurrentVariant());
      syncConvermaxFitmentTable();
      resolveFitmentState();

      [250, 800, 1800, 3500, 6000].forEach(function (delay) {
        window.setTimeout(function () {
          lastAppliedFitmentKey = '';
          scheduleFitmentResolve(0);
        }, delay);
      });

    });
  });

  /* MOCKUP 2026-10-02: the "add anyway" override handler was removed (Add to Cart is never hidden). */

/* Position badge + buy-box line — fetched from the projection (same source as the collection card),
   so it shows on every brand with a Position, with no metafield writes. Appended 2026-08-27. */
(function(){
  try{
    var m=location.pathname.match(/\/products\/([^\/?#]+)/); if(!m) return;
    var API='https://carpartglobal-api-743237931312.us-central1.run.app';
    fetch(API+'/storefront/product/facts?handle='+encodeURIComponent(m[1]))
      .then(function(r){return r.json();}).then(function(d){
        var pos=d&&d.position; if(!pos) return; pos=String(pos).replace(/[<>]/g,'');
        /* cpg-pos-inline-v1 (2026-10-11): the pill sits in the vendor/SKU row, sized to that row's line,
           so its late (fetched) insertion cannot move anything. Under the title it pushed the buy box
           down 61px and pushed mobile CLS over 0.1 in Search Console. */
        if(!document.querySelector('.cpg-pos-badge')){
          var b=document.createElement('span'); b.className='cpg-pos-badge'; b.title='Position: '+pos;
          b.textContent='Position: '+pos;
          var row=document.querySelector('.cpg-product__meta-row');
          if(row){
            var h=Math.round(row.getBoundingClientRect().height)||17;
            b.style.cssText='display:inline-block;box-sizing:border-box;height:'+h+'px;line-height:'+h+'px;padding:0 9px;margin:0 auto 0 0;'
              +'background:#e31b23;color:#fff;font-weight:700;font-size:11px;letter-spacing:.02em;border-radius:99px;'
              +'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0;flex:0 100 auto;align-self:center';
            var vendor=row.querySelector('.cpg-product__vendor');
            if(vendor) vendor.insertAdjacentElement('afterend', b); else row.insertAdjacentElement('afterbegin', b);
          } else {
            var title=document.querySelector('.cpg-product__title');
            if(title){
              b.style.cssText='display:inline-block;margin:10px 0 24px;background:#e31b23;color:#fff;font-weight:700;font-size:12px;letter-spacing:.02em;border-radius:99px;padding:5px 14px;line-height:1.4';
              title.insertAdjacentElement('afterend', b);
            }
          }
        }
      }).catch(function(){});
  }catch(e){}
})();
